import { useQuery } from "react-query";
import { API_ENDPOINTS } from "utility/endpoints";
import { api } from "utility/interceptor";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const fetchInventory = async ({ }) => {
    const url = `${API_ENDPOINTS.INVENTORY}`;
    const { data } = await api.get(url);
    return data?.data;
};
const useInventory = (options = {}) => {
    return useQuery([API_ENDPOINTS.INVENTORY, options], fetchInventory, {
        keepPreviousData: true,
    });
};
const fetchInventoryQuery = async (id) => {
    if (id > 0 && id != undefined) {
        const { data } = await api.get(`${API_ENDPOINTS.INVENTORY}/${id}`);
        return data?.data;
    }
    else
        return {}
};
const useInventoryQuery = (id) => {
    return useQuery([API_ENDPOINTS.INVENTORY, id], () => fetchInventoryQuery(id));
};
const useDeleteInventoryMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(
        (id) => api.delete(`${API_ENDPOINTS.INVENTORY}/${id}`),
        {
            onSettled: () => {
                queryClient.invalidateQueries(API_ENDPOINTS.INVENTORY);
            },
        }
    );
};
const useBulkDeleteInventoryClassMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(
        ({ variables: { id, input } }) =>
            api.post(`${API_ENDPOINTS.INVENTORY}/remove_bulk`, input),
        {
            onSuccess: () => {
            },
            onSettled: () => {
                queryClient.invalidateQueries(API_ENDPOINTS.INVENTORY);
            },
            onError: (error) => {
                toast.error(error?.response?.data?.message);
            },
        }
    );
};
const useUpdateInventoryClassMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(
        ({ variables: { id, input } }) =>
            api.patch(`${API_ENDPOINTS.INVENTORY}/${id}`, input),
        {
            onSuccess: () => {
            },
            onSettled: () => {
                queryClient.invalidateQueries(API_ENDPOINTS.INVENTORY);
            },
            onError: (error) => {
                toast.error(error?.response?.data?.message);
            },
        }
    );
};
const useCreateInventoryClassMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(
        ({ variables: { input } }) =>
            api.post(API_ENDPOINTS.INVENTORY, input),
        {
            onSuccess: (result) => {
                console.log("result", result)
                if (result.status === 200 || result?.data?.status === 200) {
                    toast.success(result.data.message);
                } else if (result.status === 400) {
                    toast.error(result?.message);
                }
            },
            onSettled: () => {
                queryClient.invalidateQueries(API_ENDPOINTS.INVENTORY);
            },
            onError: (error) => {
                toast.error(error?.response?.data?.message);
            },
        }
    );
};
export {
    useInventory,
    useInventoryQuery,
    fetchInventory,
    useCreateInventoryClassMutation,
    useUpdateInventoryClassMutation,
    useDeleteInventoryMutation,
    useBulkDeleteInventoryClassMutation
};
